/* Couples Set PDP — gallery (slides + video + lightbox), ring-sizer modal + dial, sticky ATC, ATC options gate */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  var RS_SIZES = [
    {us:'4',dia:14.9,circ:46.8,uk:'H½',eu:47},
    {us:'4.5',dia:15.3,circ:48.0,uk:'I½',eu:48},
    {us:'5',dia:15.7,circ:49.3,uk:'J½',eu:49},
    {us:'5.5',dia:16.1,circ:50.6,uk:'K½',eu:51},
    {us:'6',dia:16.5,circ:51.9,uk:'L½',eu:52},
    {us:'6.5',dia:16.9,circ:53.1,uk:'M½',eu:53},
    {us:'7',dia:17.3,circ:54.4,uk:'N½',eu:54},
    {us:'7.5',dia:17.7,circ:55.7,uk:'O½',eu:56},
    {us:'8',dia:18.1,circ:57.0,uk:'P½',eu:57},
    {us:'8.5',dia:18.5,circ:58.3,uk:'Q½',eu:58},
    {us:'9',dia:18.9,circ:59.5,uk:'R½',eu:60},
    {us:'9.5',dia:19.4,circ:60.8,uk:'S½',eu:61},
    {us:'10',dia:19.8,circ:62.1,uk:'T½',eu:62},
    {us:'10.5',dia:20.2,circ:63.4,uk:'U½',eu:63},
    {us:'11',dia:20.6,circ:64.6,uk:'V½',eu:65},
    {us:'11.5',dia:21.0,circ:65.9,uk:'W½',eu:66},
    {us:'12',dia:21.4,circ:67.2,uk:'Y',eu:67},
    {us:'12.5',dia:21.8,circ:68.5,uk:'Z',eu:69},
    {us:'13',dia:22.2,circ:69.7,uk:'Z+1',eu:70},
    {us:'13.5',dia:22.6,circ:71.0,uk:'Z+2',eu:71},
    {us:'14',dia:23.0,circ:72.3,uk:'Z+3',eu:72},
    {us:'14.5',dia:23.4,circ:73.6,uk:'Z+4',eu:74},
    {us:'15',dia:23.8,circ:74.8,uk:'Z+5',eu:75}
  ];

  ready(function () {
    /* title "Read more" — only shown when the 2-line clamp actually truncates the title */
    var title = document.getElementById('cspTitle');
    var titleMore = document.getElementById('cspTitleMore');
    if (title && titleMore) {
      var checkClamp = function () {
        if (title.classList.contains('expanded')) return;
        titleMore.hidden = (title.scrollHeight - title.clientHeight <= 1);
      };
      titleMore.addEventListener('click', function () {
        var expanded = title.classList.toggle('expanded');
        titleMore.textContent = expanded ? 'Read less' : 'Read more';
        titleMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      checkClamp();
      window.addEventListener('resize', checkClamp);
      window.addEventListener('load', checkClamp);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkClamp);
    }

    /* gallery — thumbnails toggle slides; videos pause when their slide is hidden */
    var slides = document.querySelectorAll('.csp-slide');
    var thumbs = document.querySelectorAll('.csp-thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-idx');
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        slides.forEach(function (s) {
          var on = s.getAttribute('data-idx') === idx;
          s.classList.toggle('active', on);
          var vid = s.querySelector('video');
          if (vid && !on && !vid.paused) vid.pause();
        });
      });
    });

    /* arrow / swipe navigation — steps by clicking the matching thumb (reuses the
       handler above, so videos pause correctly); keeps the active thumb in view
       when the mobile thumb row scrolls (horizontal only, never scrolls the page) */
    function cspStep(d) {
      var n = thumbs.length;
      if (n < 2) return;
      var cur = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('active')) cur = i; });
      var t = thumbs[((cur + d) % n + n) % n];
      t.click();
      var tw = t.parentElement;
      if (tw && tw.scrollWidth > tw.clientWidth) {
        var target = t.offsetLeft - (tw.clientWidth - t.offsetWidth) / 2;
        if (tw.scrollTo) { tw.scrollTo({ left: target, behavior: 'smooth' }); } else { tw.scrollLeft = target; }
      }
    }
    var navPrev = document.querySelector('.csp-nav-prev');
    var navNext = document.querySelector('.csp-nav-next');
    if (navPrev) navPrev.addEventListener('click', function () { cspStep(-1); });
    if (navNext) navNext.addEventListener('click', function () { cspStep(1); });
    var galMain = document.querySelector('.csp-main');
    if (galMain && thumbs.length > 1) {
      var swX = 0, swY = 0, swOn = false;
      galMain.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swOn = false; return; }
        swOn = true; swX = e.touches[0].clientX; swY = e.touches[0].clientY;
      }, { passive: true });
      galMain.addEventListener('touchend', function (e) {
        if (!swOn) return;
        swOn = false;
        var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) cspStep(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    /* video slides — click anywhere on the video to play/pause; icon hides while playing */
    slides.forEach(function (sl) {
      var vid = sl.querySelector('video');
      var vbtn = sl.querySelector('.csp-video-btn');
      if (!vid || !vbtn) return;
      var sync = function () {
        var playing = !vid.paused && !vid.ended;
        sl.classList.toggle('playing', playing);
        vbtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      };
      vbtn.addEventListener('click', function () {
        if (vid.paused || vid.ended) { vid.play().catch(function () {}); } else { vid.pause(); }
      });
      vid.addEventListener('play', sync);
      vid.addEventListener('pause', sync);
      vid.addEventListener('ended', sync);
      sync();
    });

    /* lightbox — click the active image slide to zoom (2048px source) */
    var lb = document.getElementById('cspLightbox');
    var lbImg = document.getElementById('cspLbImg');
    var mainWrap = document.querySelector('.csp-main');
    if (lb && lbImg && mainWrap) {
      mainWrap.addEventListener('click', function (e) {
        var img = e.target.closest ? e.target.closest('.csp-slide.active img[data-zoom]') : null;
        if (!img) return;
        lbImg.src = img.getAttribute('data-zoom');
        lbImg.alt = img.alt || '';
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      var lbClose = function () { lb.hidden = true; lbImg.removeAttribute('src'); document.body.style.overflow = ''; };
      lb.addEventListener('click', lbClose);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) lbClose(); });
    }

    /* delivery estimate — merchant-declared rules (cutoff hour CT, min-max business
       days processing, min-max business days transit). Saturdays count as ship/delivery
       days when data-saturdays=1 (USPS Saturday pickup); Sundays always skipped;
       holidays are not. Dates recompute from the visitor's clock every minute. */
    var del = document.getElementById('cspDelivery');
    if (del) {
      var updateDelivery = function () {
        var cutoff = +del.getAttribute('data-cutoff') || 8;
        var pmin = +del.getAttribute('data-processing-min') || 0;
        var pmax = Math.max(pmin, +del.getAttribute('data-processing') || 2);
        var tmin = +del.getAttribute('data-transit-min') || 3;
        var tmax = +del.getAttribute('data-transit-max') || 5;
        var sat = del.getAttribute('data-saturdays') === '1';
        var chi = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
        var isBiz = function (d) { var w = d.getDay(); return w !== 0 && (sat || w !== 6); };
        var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; };
        var beforeCutoff = isBiz(chi) && chi.getHours() < cutoff;
        var start = new Date(chi);
        if (!beforeCutoff) { do { start.setDate(start.getDate() + 1); } while (!isBiz(start)); }
        var arrMin = addBiz(addBiz(start, pmin), tmin);
        var arrMax = addBiz(addBiz(start, pmax), tmax);
        var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
        var dates = document.getElementById('cspDeliveryDates');
        /* keep the whole range on one line — without this the break lands between month and
           day ("Sep" / "8"), splitting a date across two lines */
        if (dates && dates.style.whiteSpace !== 'nowrap') dates.style.whiteSpace = 'nowrap';
        if (dates) dates.textContent = fmt(arrMin) + ' – ' + fmt(arrMax);
      };
      updateDelivery();
      setInterval(updateDelivery, 60000);
    }

    /* Reassurance under the buy button. "Free engraving" is already promised twice directly
       above — the $30 badge and the Add Engraving control — so repeating it here is noise.
       TEXT ONLY: no colour or weight override. An earlier version made this green + bold to
       match .csp-sizenote-1, which was wrong — green already appears three times in this buy
       box, the checkmark device twice, and a saturated colour directly under the navy CTA
       competes with it. This line's job is to be found by someone looking for it, not to
       shout. The theme's own muted navy is correct; leave it alone. */
    var reassure = document.querySelector('.csp-reassure');
    if (reassure) reassure.textContent = 'Hassle-free returns';

    /* ATC options gate — the buy buttons render disabled and unlock only once the
       options app (VOPO/BCPO) has injected its properties fields into #csp-form.
       Prevents sizeless orders during the app's (sometimes very long) load window. */
    var gateBtns = document.querySelectorAll('[data-gate="options"]');
    var atcNote = document.getElementById('cspAtcNote');
    var cspForm = document.getElementById('csp-form');
    if (gateBtns.length && cspForm) {
      var hasOptions = function () {
        return !!cspForm.querySelector('select[name^="properties"], input[name^="properties"], textarea[name^="properties"]');
      };
      var unlock = function () {
        gateBtns.forEach(function (b) { b.disabled = false; });
        if (atcNote) atcNote.hidden = true;
        /* move the size-exchange note directly under the Her Ring Size dropdown
           (VOPO injects its fields at an unpredictable position in the form) */
        var note = document.getElementById('cspSizeNote');
        var her = cspForm.querySelector('select[name="properties[Her Ring Size]"]');
        if (note && her) {
          var wrap = her.closest('.selector-wrapper') || her.parentElement;
          if (wrap && wrap.parentElement) wrap.parentElement.insertBefore(note, wrap.nextSibling);
        }
        /* move the "Free engraving included / $30 value" badge down so it heads the engraving
           block it describes, instead of sitting above both size dropdowns. It renders outside
           #csp-form while the checkbox is injected inside, so this can only run once the app has
           settled — the same reason the size note above is relocated here.
           POSITION ONLY — no styling of any kind is applied. */
        var badge = document.querySelector('.csp-engrave');
        var engWrap = null;
        Array.prototype.slice.call(cspForm.querySelectorAll('.selector-wrapper')).forEach(function (g) {
          var t = g.querySelector('.bcpo-title');
          if (t && /add engraving/i.test(t.textContent || '')) engWrap = g;
        });
        if (badge && engWrap && engWrap.parentElement) engWrap.parentElement.insertBefore(badge, engWrap);
        /* Move "Find my ring size" below the size pair. Above the fields it answers a question
           the shopper has not been asked yet; below, it lands exactly where they stall.
           Inserted after the note above, so it ends up first: [sizes][link][note]. */
        var sizeLink = document.querySelector('.csp-sizelink');
        if (sizeLink && her) {
          var hw = her.closest('.selector-wrapper') || her.parentElement;
          if (hw && hw.parentElement) {
            hw.parentElement.insertBefore(sizeLink, hw.nextSibling);
            sizeLink.style.margin = '0 0 10px';
            var a = sizeLink.querySelector('a');
            if (a && !a.querySelector('svg')) {
              a.style.display = 'inline-flex';
              a.style.alignItems = 'center';
              a.style.gap = '6px';
              a.style.fontWeight = '500';
              /* a ruler: body plus graduated tick marks. The previous path drew a hexagon —
                 wrong icon entirely. */
              a.insertAdjacentHTML('afterbegin',
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<rect x="2" y="8" width="20" height="8" rx="1.5"/>' +
                '<path d="M6.5 8v3M10 8v4M13.5 8v3M17.5 8v4"/></svg>');
            }
          }
        }
        /* The strongest sizing reassurance this store has is that a sizer ships with the ring —
           it removes the hesitation without asking anyone to wait. Replaces the guess advice,
           which manufactured the exchanges the guarantee then paid for. */
        var n1 = document.querySelector('.csp-sizenote-1');
        var n2 = document.querySelector('.csp-sizenote-2');
        if (n1) n1.textContent = '✓ A ring sizer ships with every order';
        if (n2) n2.textContent = 'Confirm at home — free size exchange.';
      };
      if (hasOptions()) {
        unlock();
      } else {
        var mo = new MutationObserver(function () {
          if (hasOptions()) { unlock(); mo.disconnect(); }
        });
        mo.observe(cspForm, { childList: true, subtree: true });
      }
    }

    /* ring sizer modal */
    var modal = document.getElementById('rsModal');
    if (modal) {
      var openBtn = document.getElementById('cspSizeOpen');
      var cal = document.getElementById('rsCal');
      var card = document.getElementById('rsCard');
      var size = document.getElementById('rsSize');
      var ring = document.getElementById('rsRing');
      var read = document.getElementById('rsReadout');

      function update() {
        if (!cal || !size) return;
        var cardPx = +cal.value;
        if (card) {
          /* ISO ID-1 card = 85.6mm tall x 53.98mm wide (held upright). Set both
             dimensions explicitly so the short side stays accurate regardless of
             any theme .rs-card overrides. */
          card.style.setProperty('height', cardPx + 'px', 'important');
          card.style.setProperty('width', (Math.round(cardPx * 53.98 / 85.6 * 10) / 10) + 'px', 'important');
          card.style.setProperty('max-width', 'none', 'important');
        }
        var pxPerMm = cardPx / 85.6;
        var s = RS_SIZES[+size.value];
        var d = Math.round(s.dia * pxPerMm);
        if (ring) {
          /* the ring's inside diameter should equal the INNER edge of the stroke,
             so grow the (border-box) circle by the stroke width on each side */
          var bw = parseFloat(getComputedStyle(ring).borderTopWidth) || 1;
          var outer = d + 2 * bw;
          ring.style.width = outer + 'px';
          ring.style.height = outer + 'px';
        }
        if (read) read.textContent = 'US ' + s.us + '  ·  ' + s.dia + ' mm  ·  UK ' + s.uk + '  ·  EU ' + s.eu;
      }
      function show() { modal.hidden = false; document.body.style.overflow = 'hidden'; update(); }
      function hide() { modal.hidden = true; document.body.style.overflow = ''; }

      if (openBtn) openBtn.addEventListener('click', show);
      modal.querySelectorAll('[data-rs-close]').forEach(function (el) { el.addEventListener('click', hide); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) hide(); });

      /* ---------- sizing methods: order fastest-first, then offer the mailed sizer ----------
         Theme ships tabs as print / dial / chart with print landing. Printable is the only
         method needing a printer, so it should not be the default; the dial works with any
         screen and a bank card. Runs BEFORE the tab click handlers below so the new tab is
         wired by the same code as the originals. Styles are inline on purpose — the .rs-btn
         classes are defined for the standalone sizer page, not verified inside this modal. */
      var rsTabs = modal.querySelector('.rs-tabs');
      if (rsTabs) {
        /* Four labels no longer fit the modal width, and the theme's tab strip wraps them —
           "Ring size dial" was breaking across three lines. Make it a single swipeable row
           instead: labels never wrap, the strip scrolls horizontally, scrollbar hidden.
           Injected as a scoped stylesheet rather than inline styles so it also covers the
           ::-webkit-scrollbar pseudo-element, which inline styles cannot reach. */
        if (!document.getElementById('rs-tabstrip-css')) {
          var tabCss = document.createElement('style');
          tabCss.id = 'rs-tabstrip-css';
          tabCss.textContent =
            '#rsModal .rs-tabs{display:flex;flex-wrap:nowrap;overflow-x:auto;gap:20px;' +
            'scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch}' +
            '#rsModal .rs-tabs::-webkit-scrollbar{display:none}' +
            '#rsModal .rs-tab{white-space:nowrap;flex:0 0 auto}';
          document.head.appendChild(tabCss);
        }
        var rsTab = function (k) { return modal.querySelector('.rs-tab[data-tab="' + k + '"]'); };
        var rsPanel = function (k) { return modal.querySelector('.rs-panel[data-panel="' + k + '"]'); };
        ['dial', 'chart', 'print'].forEach(function (k) {
          var t = rsTab(k); if (t) rsTabs.appendChild(t);
          var p = rsPanel(k); if (p) p.classList.remove('active');
          if (t) t.classList.remove('active');
        });
        var dTab = rsTab('dial'), dPanel = rsPanel('dial');
        if (dTab) dTab.classList.add('active');
        if (dPanel) dPanel.classList.add('active');

        if (!rsTab('mail')) {
          var mTab = document.createElement('button');
          mTab.type = 'button';
          mTab.className = 'rs-tab';
          mTab.setAttribute('data-tab', 'mail');
          mTab.textContent = 'Free sizer by mail';
          rsTabs.appendChild(mTab);

          var mPanel = document.createElement('div');
          mPanel.className = 'rs-panel';
          mPanel.setAttribute('data-panel', 'mail');
          mPanel.innerHTML =
            '<div style="background:#F7F4FC;border-radius:10px;padding:14px;">' +
              '<p style="margin:0 0 6px;font-size:14px;font-weight:500;color:#3C3489;">Rather size before you order?</p>' +
              '<p style="margin:0 0 12px;font-size:13px;line-height:1.5;color:#534AB7;">We\'ll mail you a free plastic sizer with $5 credit toward your ring. US only. A sizer also ships with every ring order.</p>' +
              '<form method="post" action="/cart/add">' +
                '<input type="hidden" name="id" value="45538170404995">' +
                '<button type="submit" style="width:100%;background:#4C3799;color:#fff;border:0;border-radius:9px;padding:12px;font:inherit;font-size:14px;font-weight:500;cursor:pointer;">Get a free ring sizer</button>' +
              '</form>' +
            '</div>';
          var allPanels = modal.querySelectorAll('.rs-panel');
          var lastPanel = allPanels[allPanels.length - 1];
          if (lastPanel && lastPanel.parentElement) lastPanel.parentElement.appendChild(mPanel);
        }
      }

      modal.querySelectorAll('.rs-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          modal.querySelectorAll('.rs-tab').forEach(function (x) { x.classList.remove('active'); });
          modal.querySelectorAll('.rs-panel').forEach(function (x) { x.classList.remove('active'); });
          tab.classList.add('active');
          var p = modal.querySelector('.rs-panel[data-panel="' + tab.getAttribute('data-tab') + '"]');
          if (p) p.classList.add('active');
        });
      });

      if (cal) cal.addEventListener('input', update);
      if (size) size.addEventListener('input', update);

      var body = document.getElementById('rsChartBody');
      if (body) {
        RS_SIZES.forEach(function (s) {
          var tr = document.createElement('tr');
          tr.innerHTML = '<td>' + s.us + '</td><td>' + s.dia + ' mm</td><td>' + s.circ + ' mm</td><td>' + s.uk + '</td><td>' + s.eu + '</td>';
          body.appendChild(tr);
        });
      }
    }

    /* sticky add-to-cart — show once the main ATC has scrolled above the viewport.
       Uses a scroll listener (reliable everywhere) rather than IntersectionObserver. */
    var sticky = document.getElementById('cspSticky');
    var atc = document.querySelector('.csp-atc');
    if (sticky && atc) {
      var syncSticky = function () {
        sticky.classList.toggle('show', atc.getBoundingClientRect().bottom <= 0);
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }

    /* related products — fetch Shopify product recommendations and swap them in
       (replaces the fallback collection rendered on first paint) */
    var recBody = document.querySelector('.couples-related [data-csp-recommendations]');
    if (recBody) {
      fetch(recBody.getAttribute('data-csp-recommendations'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.cs-prow');
          if (fresh) { recBody.innerHTML = ''; recBody.appendChild(fresh); }
        })
        .catch(function () {});
    }
  });
})();
